import React, { ReactNode } from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

type Props = {
  children: ReactNode;
  className?: string;
  theme?: string;
};

export default function SurveyContent({ children, className, theme = 'white' }: Props) {
  return (
    <div className={cn(styles.surveyContent, className)}>
      {children}
    </div>
  );
};